import {
    addDoc,
    getDocs,
    collection,
    // updateDoc,
    query,
    where,
    setDoc
} from 'firebase/firestore'
import { db } from '../firebase'
export default class CMS {
    constructor() {
        this.KEY = 'CMS'
    }
    async getCMS(title) {
        try {
            const q = query(collection(db, this.KEY),
                where("title", "==", title),
            )
            const n = await getDocs(q);
            let r = []
            n.forEach((doc) => {
                r.push({ id: doc.id, ...doc.data() })
            });
            return r?.[0]
        } catch (error) {
            console.error(error);
            return {}
        }
    }
    async addCMS(params) {
        try {
            // Check if a document with the same title already exists
            const q = query(collection(db, this.KEY), where("title", "==", params.title));
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                // Document exists, so update it
                const docRef = querySnapshot.docs[0].ref;
                await setDoc(docRef, params, { merge: true });
                return docRef.id;
            } else {
                // Document does not exist, so create a new one
                const newDocRef = await addDoc(collection(db, this.KEY), params);
                return newDocRef.id;
            }
        } catch (error) {
            console.error(error, params);
            return {};
        }
    }


}